import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { MAINTENANCE } from './maintenance';

/**
 * client side auto redirect to maintenance page
 *
 * WHY:
 * we do the redirect on the server side, but we need to redirect the client side as well
 *
 * WHEN
 * the maintenance window starts BUT user has a loaded view
 */
export const useMaintenanceClientAutoRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    if (MAINTENANCE.isSet() && router.pathname.startsWith('/maintenance')) {
      return;
    }

    const tryRedirectToMaintenanceIfPastMaintenanceStart = () => {
      if (MAINTENANCE.isActive()) {
        router.push('/maintenance');
      }
    };

    tryRedirectToMaintenanceIfPastMaintenanceStart();

    if (
      /**
       * we start the interval ticking 6 hours before the maintenance window starts
       * so that we catch all cached client views opened before the maintenance start
       */
      MAINTENANCE.isClientSideIntervalRedirectActive()
    ) {
      const interval = setInterval(() => {
        tryRedirectToMaintenanceIfPastMaintenanceStart();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [router]);
};
